import { createContext, useEffect, useState } from 'react'
import { Tooltip, Button } from 'antd'
import useUrlStore from '@/stores/UrlStore'

const ShortlinkBtn = ({ type, ...props }) => {
  const [openShorturlDrawer] = useUrlStore((state) => [state.openDrawer])

  return (
    <>
      <Tooltip title='短链接'>
        {type === 'link' ? (
          <Button type={'link'} onClick={() => openShorturlDrawer()}>
            短链接
          </Button>
        ) : (
          <Button type='text' onClick={() => openShorturlDrawer()} size={'middle'} className='px-1'>
            🔗
          </Button>
        )}
      </Tooltip>
    </>
  )
}
export default ShortlinkBtn
